import { createSelector } from 'reselect';
import { getAssetManagerShowPlanView, getColorSchemeForBand, getColorSchemeForStatus } from '..';

export const getChartistColorsForSummary = createSelector(
  [getAssetManagerShowPlanView, getColorSchemeForBand, getColorSchemeForStatus],
  (showPlanView, color1, color2) => (showPlanView ? color1 : color2),
);
